import React from "react";
import { ArrowRight, Phone, Star, ShieldCheck, Sparkles } from "lucide-react";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_polish-medford/artifacts/cixa4lte_the-best-car-wash-soap-for-a-cleaner-car.webp";

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative bg-white">
      <div className="absolute inset-0 bg-grid pointer-events-none" />
      <div className="container mx-auto px-6 md:px-12 relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 pt-16 md:pt-24 pb-20 md:pb-28 items-center">
          <div className="lg:col-span-7 reveal">
            <div className="inline-flex items-center gap-2 border border-slate-200 bg-white px-3 py-1.5 text-[11px] tracking-[0.25em] uppercase font-semibold text-slate-600 mb-8">
              <span className="h-2 w-2 bg-blue-600" />
              Medford · Southern Oregon
            </div>

            <h1 className="font-display font-black text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tighter text-slate-900">
              Showroom shine.<br />
              <span className="text-blue-600">Delivered to your driveway.</span>
            </h1>

            <p className="mt-7 max-w-xl text-lg text-slate-600 leading-relaxed">
              Professional mobile auto detailing serving Medford, Ashland, Grants
              Pass and surrounding Southern Oregon communities. Hand finished
              results, every time.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a
                href="#book"
                data-testid="hero-book-cta"
                className="inline-flex items-center gap-3 bg-blue-600 hover:bg-blue-700 px-8 py-4 text-sm font-bold text-white transition-all hover:-translate-y-1 shadow-md hover:shadow-xl"
              >
                Book online
                <ArrowRight size={18} strokeWidth={2.5} />
              </a>
              <a
                href="tel:5416222960"
                data-testid="hero-call-cta"
                className="inline-flex items-center gap-3 border-2 border-slate-900 px-8 py-4 text-sm font-bold text-slate-900 transition-all hover:bg-slate-900 hover:text-white hover:-translate-y-1"
              >
                <Phone size={18} strokeWidth={2.5} />
                Call 541-622-2960
              </a>
            </div>

            <div className="mt-12 grid grid-cols-3 gap-6 max-w-lg">
              <div data-testid="trust-rating">
                <div className="flex items-center gap-1 text-blue-600">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={14} fill="currentColor" strokeWidth={0} />
                  ))}
                </div>
                <div className="mt-2 font-display font-black text-2xl">5.0</div>
                <div className="text-xs text-slate-500 uppercase tracking-wider">Rating</div>
              </div>
              <div data-testid="trust-vehicles">
                <Sparkles size={18} className="text-blue-600" />
                <div className="mt-2 font-display font-black text-2xl">200+</div>
                <div className="text-xs text-slate-500 uppercase tracking-wider">
                  Vehicles detailed
                </div>
              </div>
              <div data-testid="trust-local">
                <ShieldCheck size={18} className="text-blue-600" />
                <div className="mt-2 font-display font-black text-2xl">100%</div>
                <div className="text-xs text-slate-500 uppercase tracking-wider">
                  Locally owned
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 reveal" style={{ animationDelay: "0.15s" }}>
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-full h-full bg-blue-600" />
              <img
                src={HERO_IMG}
                alt="Pristine detailed car"
                className="relative w-full h-[420px] md:h-[560px] object-cover"
                data-testid="hero-image"
              />
              <div className="absolute bottom-4 left-4 right-4 bg-white/95 backdrop-blur p-5 border border-slate-200">
                <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-blue-600">
                  Now booking
                </div>
                <div className="font-display font-black text-xl mt-1 text-slate-900">
                  Mobile service · 7 days a week
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="relative overflow-hidden border-y border-slate-200 py-5">
          <div className="flex gap-12 animate-marquee whitespace-nowrap">
            {[...Array(2)].flatMap((_, i) =>
              [
                "Medford", "Ashland", "Grants Pass", "Central Point",
                "Jacksonville", "Phoenix", "Talent", "Eagle Point", "White City",
              ].map((c) => (
                <span
                  key={`${i}-${c}`}
                  className="font-display font-black text-2xl uppercase tracking-tight text-slate-300 flex items-center gap-12"
                >
                  {c}
                  <span className="h-1.5 w-1.5 bg-blue-600 rounded-full" />
                </span>
              ))
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
